import { memo } from "react";
import useInbox from "hooks/useInbox.ts";
import { useContent } from "contexts/contentContext/contentContext";

import "./styles.scss";

type CounterNameT =
  | "received"
  | "sent"
  | "all"
  | "trash"
  | "jmail"
  | "jform"
  | "jpay"
  | "inboxPendingDownload"
  | "jFormsPendingDownload";

type CounterPropT = {
  counterName: CounterNameT;
  className?: string;
  counter?: number;
};

const Counter = memo(({ counterName, className, counter }: CounterPropT) => {
  const { getMailsCount } = useInbox();
  const { getTextByKey } = useContent();

  const count = counter || getMailsCount()?.[counterName];

  // Ilona asked to hide the counter until the issue with the Pending download status will not be fixed 
  return <></>;

  // return (
  //   !!count && (
  //     //@ts-ignore
  //     <Tooltip
  //       tooltipTextKey={getTextByKey(
  //         `emails-count-notification-pending-download`
  //       ).replace("%value%", count)}
  //       margin={40}
  //     >
  //       <span className={`counter-wrapper ${className}`}>{count}</span>
  //     </Tooltip>
  //   )
  // );
});

export default Counter;
